import React from "react";
import { Link } from "react-router-dom";
import { Wallet, Users, Phone, ChevronLeft, HandCoins } from "lucide-react";
import { Kpi, Section, Empty } from "./ui";
import { money, num, dateAr } from "./format";

export default function DebtsTab({ data }) {
  const p = data.period;
  return (
    <div className="space-y-4 md:space-y-6" data-testid="debts-tab">
      <div className="grid grid-cols-2 md:grid-cols-6 gap-3 md:gap-4">
        <Kpi big label="إجمالي الديون المستحقة الآن" value={money(data.outstanding_total)} tone="amber" testid="debts-outstanding" sub={`${num(data.open_debt_sales)} عملية بيع مفتوحة · ${num(data.debtors.length)} زبون`} />
        <Kpi label="المقبوض ضمن الفترة" value={money(p.collected)} tone="green" testid="debts-collected" sub={`منها دفعات ديون: ${money(p.debt_payments_collected)}`} />
        <Kpi label="ديون جديدة ضمن الفترة" value={money(p.new_debt_value)} tone="primary" testid="debts-new" sub={`${num(p.new_debt_sales)} عملية بيع بالآجل`} />
        <Kpi label="مستحق للزبائن (الآن)" value={money(data.customer_credit_total)} tone="red" testid="debts-credit" sub={`${num(data.credit_sales)} عملية · أُعيد ضمن الفترة ${money(p.refunds_paid)}`} />
        <Kpi label="ديون أُغلقت (كل الوقت)" value={num(data.completed_debt_sales)} tone="gray" testid="debts-completed" sub="لا تُحتسب ضمن المستحق" />
      </div>

      <Section title="من يدين لك" icon={Users} testid="debtors-list">
        {data.debtors.length === 0 ? <Empty text="لا ديون مستحقة حالياً 🎉" testid="debtors-empty" /> : (
          <div className="divide-y divide-[#EBF4F6]">
            {data.debtors.map((d, i) => (
              <Link key={`${d.customer_name}-${d.customer_phone}`} to={`/debts?sale=${d.sale_ids[0]}`} className="flex items-center gap-3 py-3 hover:bg-[#F7FBFC] -mx-2 px-2 rounded-lg" data-testid={`debtor-${i}`}>
                <span className="w-8 h-8 rounded-full bg-amber-50 text-amber-700 font-extrabold text-sm flex items-center justify-center shrink-0">{i + 1}</span>
                <div className="flex-1 min-w-0">
                  <div className="font-bold text-[#333333] truncate">{d.customer_name}</div>
                  <div className="text-xs text-[#777777] flex flex-wrap gap-x-3">
                    {d.customer_phone && <span className="flex items-center gap-1" dir="ltr"><Phone size={11} /> {d.customer_phone}</span>}
                    <span>{num(d.open_sales)} عملية</span>
                    <span>آخر حركة: {dateAr(d.last_date)}</span>
                  </div>
                </div>
                <div className="text-lg md:text-2xl font-extrabold text-amber-600 tabular-nums shrink-0" dir="ltr" data-testid={`debtor-amount-${i}`}>{money(d.outstanding)}</div>
                <ChevronLeft size={18} className="text-[#7AB2B2] shrink-0" />
              </Link>
            ))}
          </div>
        )}
      </Section>

      {data.credits.length > 0 && (
        <Section title="زبائن لهم رصيد عندك" icon={HandCoins} testid="credits-list">
          {data.credits.map((c) => (
            <Link key={c.sale_id} to={`/debts?sale=${c.sale_id}`} className="flex items-center justify-between py-2.5 border-b border-[#EBF4F6] last:border-0" data-testid={`credit-${c.sale_id}`}>
              <span className="font-bold text-[#333333] text-sm">{c.customer_name || "زبون غير مسمّى"} {c.customer_phone && <span className="text-xs text-[#777777] font-normal" dir="ltr">· {c.customer_phone}</span>}</span>
              <span className="font-extrabold text-rose-600 tabular-nums" dir="ltr">{money(c.owed_to_customer)}</span>
            </Link>
          ))}
        </Section>
      )}
      <div className="text-[11px] text-[#888888] flex items-center gap-1"><Wallet size={12} /> تفاصيل كل دين ودفعاته وتصحيحاته في صفحة «الدين» — الأرصدة تُحسب من سجل الدفعات نفسه دون أي سجل إضافي.</div>
    </div>
  );
}
